import React from 'react';
import './Button.css';

/**
 * DangerButton Component
 * Standardized danger/destructive button with outline styling
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content
 * @param {string} size - Button size: 'small'|'medium'|'large' (default: 'medium')
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 */
const DangerButton = ({ 
  onClick, 
  children, 
  size = 'medium', 
  disabled = false, 
  className = '' 
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  
  return (
    <button
      className={`btn btn-danger ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default DangerButton;

